<div
    (click)="click()"
    (mouseenter)="hover()"
    (mouseleave)="hoverOut()"
>
    <div class="kh-info-window-title">
        <kh-field-point-icon
            class="kh-field-point-icon"
            [pointCategory]="pointCategory"
            [size]="fieldPointIconsSize.Small"
        >
        </kh-field-point-icon>
        <span>{{pointCategory.name}}</span>
    </div>
    @if (columnIdentifierValue) {
    <div class="kh-info-window-column-identifier">{{columnIdentifierValue}}</div>
    }
</div>
